import { request } from "src/utils/services";

export const getGr = async () =>
  // //id: number,
  // page: number = 1,
  // size: number = 10
  // // { page = 1, size = 10 }: { page?: number; size?: number },
  // // sort?: { field: string; dir: string },
  // // fromdate: string = "",
  // // todate: string = "",
  // // country: string = "",
  // // paymentlist: string = ""
  {
    // let query: {
    //   page: number;
    //   size: number;
    //   // type: string;
    //   // sortField?: string;
    //   // sortDir?: string;
    //   // fromdate?: string;
    //   // todate?: string;
    //   // country?: string;
    //   // paymentlist?: string;
    // } = {
    //   page,
    //   size,

    //   //type,
    //   // fromdate,
    //   // todate,
    //   // country,
    //   // paymentlist,
    // };

    // if (sort) {
    //   query.sortField = sort.field;
    //   query.sortDir = sort.dir;
    // }

    const { payload } = await request(
      "user.gr.list"
      //{ id },
      // {
      //   query,
      // }
    );

    return payload;
  };

export const getGrById = async (id: number) => {
  const { payload } = await request("user.gr.read", { id });
  return payload;
};
export const getGrGatepass = async () => {
  const { payload } = await request("user.gr.gatepass");
  return payload;
};
export const getGrGST = async () => {
  const { payload } = await request("user.gr.gst");
  return payload;
};
// export const approveTransactionById = async (id: string) => {
//   return request("admin.billing.withdraw.approve", { id });
// };
// export const getPaymentList = async () => {
//   return request("billing.paymethod", {});
// };
